// Croqui: `components/Empty.tsx`. Substitui `components/app/empty-state.tsx`.
//
// Vazio = frase + ação (`spec/17` §7 item 6). Nunca uma tabela com zero linhas e nada mais.
// WEB-133: o mesmo desenho do `EmptyState` neutro (moldura tracejada, tile de ícone neutro).

import type { ReactNode } from 'react';
import { cn } from '../../lib/cn.ts';
import { Icon, type IconName } from './icon.tsx';

export function Empty({
  icon = 'inbox',
  title,
  hint,
  action,
  className,
}: {
  icon?: IconName;
  title: string;
  hint?: string;
  action?: ReactNode;
  className?: string;
}) {
  return (
    <div
      className={cn(
        'flex flex-col items-center gap-2 rounded-2xl border border-border border-dashed px-6 py-10 text-center',
        className,
      )}
    >
      <span className="grid size-9 place-items-center rounded-lg bg-tile text-muted">
        <Icon name={icon} size={18} />
      </span>
      <div className="mt-1 text-14 font-medium">{title}</div>
      {hint !== undefined && <p className="max-w-sm text-14 text-muted text-balance">{hint}</p>}
      {action !== undefined && <div className="mt-2">{action}</div>}
    </div>
  );
}
